var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "edit-imgWrap-modal",
      attrs: {
        title: "",
        visible: _vm.show,
        "close-on-click-modal": false,
        width: "650px",
        bodyHeight: "400px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        close: _vm.onChange,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("shop-site::facebook_campaign::bind_title")) + " "
        ),
      ]),
      _c(
        "div",
        { staticClass: "img-box" },
        [
          _vm._l(_vm.images, function (item) {
            return _c(
              "div",
              { key: item.id, staticClass: "item-cell" },
              [
                _c("el-image", {
                  staticClass: "img",
                  attrs: { src: item.img || _vm.defaultImg },
                }),
                _c(
                  "div",
                  { staticClass: "cell-hover" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleItem("edit", item)
                          },
                        },
                      },
                      [_c("i", { staticClass: "iconfont iconedit edit-icon" })]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "div",
            {
              staticClass: "add-img-item item-cell",
              on: {
                click: function ($event) {
                  return _vm.handleItem("add")
                },
              },
            },
            [
              _c("div", { staticClass: "content" }, [
                _c("span", [_vm._v("+")]),
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("shop-site::facebook_campaign::upload_title"))
                  ),
                ]),
              ]),
            ]
          ),
        ],
        2
      ),
      _c("campaignItemModal", {
        attrs: { drawRow: _vm.cellItem },
        on: { save: _vm.onSaveItem },
        model: {
          value: _vm.campaignVisable,
          callback: function ($$v) {
            _vm.campaignVisable = $$v
          },
          expression: "campaignVisable",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }